import { useMutation } from '@tanstack/react-query'
import { trpc } from '../../utils/trpc'

export function useImproveFeedback() {
	const mutation = useMutation({
		...trpc.client.feedbackImprovement.improve.mutationOptions(),
	})

	return {
		improve: mutation.mutateAsync,
		isPending: mutation.isPending,
		data: mutation.data,
		reset: mutation.reset,
		error: mutation.error,
	}
}
